module.exports = __webpack_public_path__ + "static/media/speaker4.2fa5304e.jpg";